
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[area]",
      function () {
        return require("private-next-pages/search/[area].tsx");
      }
    ]);
  